<template>
  <div>
    All open security incidents, these are not specific for the selected period
    <v-data-table
      :loading="queryLoading"
      :headers="headers"
      :items="items"
      hide-default-footer
      disable-pagination
      multi-sort
    />
  </div>
</template>
<script>
import Component from "vue-class-component";
import ReportBase from "../ReportBase";
import { CATEGORY_FILTERS_ENUM } from "@/core/constants";
import { DETAILS } from "../queries.graphql";
import {
  childRefEnum,
  parentHeader
} from "@/view/content/ServiceManagementReport/constants";

@Component
class OpenSecurityIncidents extends ReportBase {
  queryLoading = false;
  items = [];
  headers = [
    { text: "Call", value: "caseNumber" },
    { text: "Subject", value: "shortDescription" },
    { text: "Severity", value: "severity" }
  ];

  async parseAndRetrieveData({ accountNumberFilter }) {
    const settings = {
      query: {
        variables: {
          filters: {
            accountNumber: accountNumberFilter,
            state: this.openIncidentFilter,
            category: { value: [CATEGORY_FILTERS_ENUM.SECURITY_INCIDENT] }
          }
        },
        query: DETAILS,
        path: "reports.serviceManagementReport.details.result"
      }
    };
    this.queryLoading = true;

    let items = await this.queryData(settings.query);
    this.items = this.setLevel({ data: items, levelName: "severity" });

    this.dataLoaded(
      childRefEnum.OPEN_SECURITY_INCIDENTS,
      parentHeader.OPEN_SECURITY_INCIDENTS
    );
    this.queryLoading = false;
  }
}
export default OpenSecurityIncidents;
</script>
